<template>
<Menu mode="horizontal" :active-name="current" @on-select="onSelect">
  <MenuItem name="study-survey">
    <Icon type="ios-speedometer" /> 概况
  </MenuItem>
  <MenuItem name="subjects">
    <Icon type="ios-create" /> 数据录入
  </MenuItem>
  <MenuItem name="diff">
    <Icon type="ios-git-compare" /> 差异比对
  </MenuItem>
  <MenuItem name="team">
    <Icon type="ios-people" /> 团队
  </MenuItem>
  <MenuItem name="site">
    <Icon type="ios-medkit" /> 中心
  </MenuItem>
  <MenuItem name="design">
    <Icon type="ios-construct" /> eCRF设计
  </MenuItem>
  <MenuItem name="lb">
    <Icon type="md-flask" /> 实验室参考值
  </MenuItem>
  <!-- <MenuItem name="check">
    <Icon type="md-checkmark-circle" /> 核查配置
  </MenuItem> -->
  <MenuItem name="querys">
    <Icon type="ios-help-circle" /> 疑问
  </MenuItem>
  <MenuItem name="export">
    <Icon type="md-cloud-download" /> 导出
  </MenuItem>
</Menu>
</template>

<script>
export default {
  name: 'study-menu',
  data: function () {
    return {
      current: 'study-survey'
    }
  },
  created: function () {
    var paths = this.$route.path.split('/')
    this.activeItem(paths.pop())
  },
  methods: {
    onSelect: function (name) {
      var baseUrl = '/study/' + this.$route.params.id
      var url = baseUrl + '/' + this.getUrl(name)
      if (name === 'study-survey') {
        url = baseUrl
      }
      this.$router.push(url)
    },
    getUrl: function (name) {
      return name.split('-').join('/')
    },
    activeItem: function (name) {
      this.current = name
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
